
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppLayout } from './components/layouts';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import { ApplicationForm } from './components/Forms';
import { ToastProvider } from './contexts/ToastContext';
import ToastNotification from './utils/ToastNotification';
import { LoadingProvider } from "./contexts/LoadingContext";
import GlobalSpinner from "./utils/GlobalSpinner";

function App() {

  return (
    <Router>
       <LoadingProvider>
       <ToastProvider>
        <ToastNotification />
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/application" element={<ApplicationForm />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ToastProvider>
      <GlobalSpinner />
       </LoadingProvider>
    </Router>
  );
}

export default App;
